import { useImperativeQuery } from '../../../common/graphql/utils';
import { GET_ANCILLARY_BUNDLE } from '../graphql/queries';

export const useGetAncillaryBundle = (selectionKey: string) => {
  return useImperativeQuery(GET_ANCILLARY_BUNDLE, {
    variables: { selectionKey },
  });
};
